import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileUploadZone',
    props: {
        file: {}
    },
    emits: ["update:file", "fileUploaded"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const fileinput = ref(null);
        const chooseFile = () => {
            var _a;
            (_a = fileinput.value) === null || _a === void 0 ? void 0 : _a.click();
        };
        const handleChange = (event) => {
            var _a;
            event.preventDefault();
            event.stopPropagation();
            if ((_a = fileinput.value) === null || _a === void 0 ? void 0 : _a.files) {
                const files = [];
                for (let i = 0; i < fileinput.value.files.length; i++) {
                    files.push(fileinput.value.files[i]);
                }
                const [file] = files;
                if (file) {
                    emit("update:file", file);
                    emit("fileUploaded");
                }
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", { onClick: chooseFile }, [
                _createElementVNode("input", {
                    ref_key: "fileinput",
                    ref: fileinput,
                    type: "file",
                    name: "file",
                    style: { "display": "none" },
                    onChange: handleChange
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
